import {find, get, cloneDeep} from 'lodash'
import projectTypes, {SIDE_HOURLY} from '@/constants/projectTypes'
import getClient from '@/mixin/getClient'
import getKPIHelpers from '@/mixin/getKPIHelpers'
import getUser from '@/mixin/getUser'
import getNotification from '@/mixin/getNotification'
import getInvoice from '@/mixin/getInvoice'
import getLastStep from '@/mixin/getLastStep'

export default {
  mixins: [getUser, getClient, getKPIHelpers, getNotification, getInvoice, getLastStep],
  methods: {
    async setProjectFullInfo (project, withoutNotification) {
      const result = cloneDeep(project)
      const { steps = [] } = result
      if (!withoutNotification) {
        // Previous logic of how we get the notifications is commented below
        // const notifications = await this.getNotification({notificationType: 1, instanceId: project.id, limit: 1})
        const notifications = { notifications: result.notifications }
        result.$notification = get(notifications, ['notifications', '0'], {})
      }
      result.projectType = find(projectTypes.concat(SIDE_HOURLY), {id: project.projectType})
      result.currentAmount = project.invoiceId ? project.currentValue : project.amount
      result.className = project.invoiceId && project.currentValue < project.amount ? 'red' : ''
      result.invoiceFile = get(result.invoice, ['uploadFile', '0'], '')
      const approveStatus = get(project, 'approveStatus', false)
      result.approveStatus = approveStatus
      const managerComment = get(project, 'managerComment', '')
      result.managerComment = managerComment
      const resultUserHelpers = get(project, 'kpiHelpUsers', [])
      result.kpiHelpUsers = await this.getKPIHelpers(resultUserHelpers)
      const factValue = get(result, 'factValue', result.currentAmount)
      result.factValue = factValue || result.currentAmount
      result.lastStep = steps[steps.length - 1]
      // Previous logic of how we get the steps is commented below
      // result.lastStep = await this.getLastStep(project.id)
      const residue = project.amount - project.currentValue
      result.$residue = isNaN(residue) ? 0 : residue
      const rejectedDate = get(project, 'rejectedDate', '')
      result.rejectedDate = rejectedDate
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setProjectFullInfo.js